export const SET_LIST = 'SET_LIST';
export const SET_ERRORS = 'SET_ERRORS';
